/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Skeleton} from '../components/skeleton/Skeleton';

// defines the prop definitions for ImportProgress
export interface ImportProgressType {
  isCompleted: boolean;
  text?: string;
  width?: number;
  height?: number;
}

/**
 * The ImportProgress provides the option to other import components to show Skeleton rectangle loader
 * when importing is in progress and show the text what needs to be shown once import is completed.
 *
 * ```typescript
 *
 * import {ImportProgress} from '@ion/dls/src/imports';
 *
 * <ImportProgress isCompleted
 *   text={fileName || fileSize}
 *   width={width}
 *   height={height} />
 *
 * ```
 *
 * @param isCompleted Check the import process is completed
 * @param text  The text that to be displayed once the import process has completed
 * @param width Skeleton width
 * @param height Skeleton height
 */
export const ImportProgress = ({
  isCompleted,
  text = '',
  width = 150,
  height = 25
}: ImportProgressType) => {
  return (
    <>
      {!isCompleted ? <Skeleton variant='rect' animation='wave' width={width} height={height} /> : text}
    </>
  );
};

export default ImportProgress;
